module.exports = __webpack_public_path__ + "static/nicolemoudaber_1-cf2e6e1801649a9326cefcbb69918e62.jpg";